export const pinDelivery = {
    showNewDeliveryContact: false,
    showAlertText: true,
};
